
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.71944 18.5669L20.2905 2.31701C20.5698 2.07264 20.5698 1.67764 20.2905 1.43327C20.0113 1.18889 19.5598 1.18889 19.2806 1.43327L15.4999 4.74137V0.625146C15.4999 0.378897 15.3356 0.155774 15.0778 0.0545247C14.8235 -0.0454746 14.5214 -0.00609989 14.3114 0.157649L8.08576 5.00011H4.07154C2.89014 5.00011 1.92872 5.84136 1.92872 6.8751V13.1251C1.92872 14.0782 2.74942 14.8594 3.80298 14.9763L0.709461 17.6832C0.43018 17.9275 0.43018 18.3225 0.709461 18.5669C0.988027 18.8113 1.44088 18.8113 1.71944 18.5669ZM15.4998 13.6953C17.5233 13.3965 19.0711 11.8559 19.0711 10.0015C19.0711 8.71342 18.3147 7.58843 17.1805 6.91406L16.144 7.82156C17.0319 8.24405 17.6426 9.05592 17.6426 10.0015C17.6426 11.1622 16.729 12.1334 15.4998 12.4121V8.3853L14.0712 9.63529V17.9852L9.07131 14.0959V14.0103L7.93848 15.0015H8.08562L14.3112 19.844C14.5148 20.0033 14.8126 20.0496 15.0776 19.9465C15.3355 19.8458 15.4998 19.6233 15.4998 19.3765V13.6953ZM9.07129 5.90435V10.3649L14.0712 5.98997V2.01562L9.07129 5.90435ZM7.64288 11.616L5.20435 13.7497H4.07151C3.67724 13.7497 3.35724 13.4691 3.35724 13.1247V6.87479C3.35724 6.53042 3.67724 6.2498 4.07151 6.2498H7.64288V11.616Z"}})])
          )
        }
      }
    